interface FormProps {
    formData: FormDataProps;
    returnUrl: string;
}
interface InputProps {
    name: string;
    value: string;
}
interface FormDataProps {
    [key: string]: string;
}

export const FormRedirect = ({ formData, returnUrl }: FormProps) => {

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = returnUrl;

    for (const [key, value] of Object.entries(formData)) {
        console.log(`${key}: ${value}`);
        form.appendChild(createInput({ name: key, value: value }));
    }

    document.body.appendChild(form);
    form.submit();
}

const createInput = ({ name, value }: InputProps) => {
    const hiddenField = document.createElement('input');
    hiddenField.type = 'hidden';
    hiddenField.name = name;
    hiddenField.value = value;
    return hiddenField;
}